import { render, staticRenderFns } from "./Popover2.vue?vue&type=template&id=5bf64bb8&"
import script from "./Popover2.vue?vue&type=script&lang=js&"
export * from "./Popover2.vue?vue&type=script&lang=js&"
import style0 from "./Popover2.vue?vue&type=style&index=0&id=5bf64bb8&prod&lang=scss&"
import style1 from "./Popover2.vue?vue&type=style&index=1&id=5bf64bb8&prod&lang=css&"
import style2 from "./Popover2.vue?vue&type=style&index=2&id=5bf64bb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports